// extracted by mini-css-extract-plugin
export var base = "_4n-0";
export var updateBanner = "_4n-1";